import CryptoJS from 'crypto-js';
const key = process.env.VUE_APP_LOCAL_STORAGE_ENCRYPTION_KEY;

export class Encryption {
	static encrypt = (value) => {
		const cipherText = CryptoJS.AES.encrypt(value, key).toString();

		return cipherText;
	};
	static decrypt = (value) => {
		const bytes = CryptoJS.AES.decrypt(value, key);
		return bytes.toString(CryptoJS.enc.Utf8);
	};
}
